module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.eot?c33c088b5e062482234a7733e3fd4884";